import { AppDispatch } from "@Reducers/index";
import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type { Exact } from "@Helpers/types/exact";
import { showToastNotification } from "../reducers/toastSlice";
import { setTaskResourceType, setResourceCreated, setTaskResource } from "../reducers/Resources";
import { t } from "@i18n";
import type {
  SaveResourceTypeRequest,
  DeleteResourceTypeRequest,
  DeleteResourceTypeResponse,
  SaveResourceRequest,
  DeleteResourceRequest,
  DeleteResourceResponse,
  DeleteResourceNewRequest,
  DeleteResourceNewResponse,
  GetResourceTypesRequest,
  GetResourceTypesResponse,
  GetResourcesNewRequest,
  GetResourcesResponse,
  SaveResourceTypeResponse,
  SaveResourceResponse,
  SaveResourceNewResponse,
  SaveResourceIdsInTaskRequest,
  SaveResourceIdsInTaskResponse,
  DeleteResourceIdsFromTaskRequest,
  DeleteResourceIdsFromTaskResponse,
  GetResourcesListRequest,
} from "@ServerTypes/resources/resources.schema";

export async function saveResourceTypeData<T extends Exact<SaveResourceTypeRequest, T>>(data: T) {
  const res = await axiosWrapper.post<SaveResourceTypeResponse>(`${getBackendUrl()}/resources/saveResourceType`, data);
  return res;
}

export function deleteResourceType<T extends Exact<DeleteResourceTypeRequest, T>>(data: T) {
  return async () => {
    await axiosWrapper.post<DeleteResourceTypeResponse>(`${getBackendUrl()}/resources/deleteResourceType`, data);
  };
}

export function saveResourceData<T extends Exact<SaveResourceRequest, T>>(data: T) {
  return async (dispatch: AppDispatch) => {
    await axiosWrapper.post<SaveResourceResponse>(`${getBackendUrl()}/resources/saveResource`, data);

    if (data._id) {
      dispatch(
        showToastNotification({
          content: t("Resource has been edited successfully!"),
        }),
      );
    } else {
      dispatch(
        showToastNotification({
          content: t("Resource has been created successfully!"),
        }),
      );
      dispatch(setResourceCreated(true));
    }
  };
}

export async function deleteResource<T extends Exact<DeleteResourceRequest, T>>(data: T) {
  const res = await axiosWrapper.post<DeleteResourceResponse>(`${getBackendUrl()}/resources/deleteResource`, data);
  return res;
}

export async function saveResourceDataNew<T extends Exact<SaveResourceRequest, T>>(data: T) {
  const res = await axiosWrapper.post<SaveResourceNewResponse>(`${getBackendUrl()}/resources/saveResourceNew`, data);
  return res;

  // if (data._id) {
  //   dispatch(
  //     showToastNotification({
  //       content: t("Resource has been edited successfully!"),
  //     }),
  //   );
  // } else {
  //   dispatch(
  //     showToastNotification({
  //       content: "Resource has been created successfully!",
  //     }),
  //   );
  // }
}

export async function deleteResourceNew<T extends Exact<DeleteResourceNewRequest, T>>(data: T) {
  const res = await axiosWrapper.post<DeleteResourceNewResponse>(
    `${getBackendUrl()}/resources/deleteResourceNew`,
    data,
  );
  return res;
}

export function getTaskResourcesTypes<T extends Exact<GetResourceTypesRequest, T>>(params: T) {
  return async (dispatch: AppDispatch) => {
    const urlParams = "/resources/getResourceTypes";
    const postData = {
      projectId: params.projectId,
    };

    const response = await axiosWrapper.post<GetResourceTypesResponse>(`${getBackendUrl()}${urlParams}`, postData);
    if (response.data.result?.length) {
      dispatch(setTaskResourceType(response.data.result));
    }
  };
}

export function getResources<T extends Exact<GetResourcesListRequest, T>>(params: T) {
  return async (dispatch: AppDispatch) => {
    const urlParams = "/resources/getResources";
    const postData = {
      projectId: params.projectId,
      scheduleId: params.scheduleId,
    };

    const response = await axiosWrapper.post<GetResourcesResponse>(`${getBackendUrl()}${urlParams}`, postData);
    if (response.data.result?.length) {
      dispatch(setTaskResource(response.data.result));
    }
  };
}

export async function getResourcesNew<T extends Exact<GetResourcesNewRequest, T>>(params: T) {
  const response = await axiosWrapper.post<GetResourcesResponse>(
    `${getBackendUrl()}/resources/getResourcesNew`,
    params,
  );
  return response.data.data;
}

export async function saveResourceIds<T extends Exact<SaveResourceIdsInTaskRequest, T>>(params: T) {
  const res = await axiosWrapper.post<SaveResourceIdsInTaskResponse>(
    `${getBackendUrl()}/resources/saveResourceIdsInTask`,
    params,
  );
  return res;
}

export async function deleteResourceIds<T extends Exact<DeleteResourceIdsFromTaskRequest, T>>(params: T) {
  const res = await axiosWrapper.post<DeleteResourceIdsFromTaskResponse>(
    `${getBackendUrl()}/resources/deleteResourceIdsFromTask`,
    params,
  );
  return res;
}
